import React, { useRef, useState, Fragment } from 'react'
import { Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const CustomSpinner = styled(Spinner)`
  margin: 0 0.313em;
`
export default function AccountRow({ data, account, removeAccount }) {
  const accountRef = useRef(account)
  const [spin, setSpin] = useState(false)

  const renderSpinner = account => {
    if (account === accountRef.current.className) {
      setSpin(true)
    }
  }

  const handleClick = account => {
    renderSpinner(account)
    removeAccount(account)
  }

  return (
    <Fragment>
      <tr className={account} ref={accountRef} key={account}>
        <td>{account}</td>
        <td>{data.username}</td>
        <td>{data.followers}</td>
        <td>N/A</td>
        <td>N/A</td>
        <td>
          <button
            className="btn btn-outline-dark"
            onClick={() => handleClick(account)}
          >
            Remove
            {spin && <CustomSpinner size="sm" animation="border" />}
          </button>
        </td>
      </tr>
    </Fragment>
  )
}
AccountRow.propTypes = {
  data: PropTypes.any,
  account: PropTypes.any,
  removeAccount: PropTypes.func,
}
